module.exports = __webpack_public_path__ + "img/ignis2024.a394f35a.png";